export default __webpack_public_path__ + "static/media/pkb-6.396a1326.png";